import { supabase } from "@/integrations/supabase/client";
import { getUtmData } from "@/hooks/useUtmCapture";

type ConversionEvent =
  | "cta_click"
  | "lead_submit"
  | "contact_form"
  | "registration_start"
  | "page_scroll_75";

/**
 * Tracks a conversion event with UTM attribution.
 * Stores in the conversions table for performance analysis.
 */
export async function trackConversion(
  event: ConversionEvent,
  metadata?: Record<string, string>
) {
  const utm = getUtmData();

  try {
    await supabase.from("conversions" as any).insert({
      event,
      page: window.location.pathname,
      utm_source: utm?.utm_source || null,
      utm_medium: utm?.utm_medium || null,
      utm_campaign: utm?.utm_campaign || null,
      utm_content: utm?.utm_content || null,
      referrer: document.referrer || null,
      metadata: metadata || null,
    } as any);
  } catch {
    // Silent fail — tracking should never break the UX
  }
}
